import styled, { keyframes } from 'styled-components';


const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;


const rotateRight = keyframes`
    from {
      transform: none;
    }
    to {
      transform: rotate(360deg);
    }
`;

const rotateLeft = keyframes`
    from {
      transform: none;
    }
    to {
      transform: rotate(-360deg);
    }
`;

const StyledVisualization = styled.div`

  position: absolute;
  top: 0;
  right: 0;
  bottom: auto;
  width: 50%;
  height: ${props => props.slideHeight}px;
  background-color: #a90060;
  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  z-index: 2;
  text-align: center;
  padding-top: 3rem;

  h3 {
    font-size: 3rem;
    color: #fff;
    padding: 3rem;
  }

  .af-svg-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }

  svg {
    width: 96%;
    height: 96%;
    animation: ${fadeIn} 1s ease;
    text {
      user-select: none;
    }
    .cogs:hover {
      .cog1 {
        animation: ${rotateRight} 1s linear infinite;
        pointer-events: none;
      }
      .cog2 {
        animation: ${rotateLeft} 1.1s linear infinite;
        pointer-events: none;
      }
      .cog3 {
        animation: ${rotateRight} 1.2s linear infinite;
        pointer-events: none;
      }
    }
  }

  .af-tooltip-hoe {
    text-align: left !important;
    position: absolute !important;
    margin-top: -40px !important;
  }


  @media (max-width: 576px) {
    position: relative;
    width: 100%;
    height: 300px;
  }

`;

export default StyledVisualization;



// WEBPACK FOOTER //
// ./src/components/Visualization/StyledVisualization.js